<template>
  <div class="field" v-show="visible">
    <div class="text-selection-container">
      <question-attributes :colors="colors" :field="field"></question-attributes>
      <textarea
        class="text-field text-field-input"
        :class="{hasText: field.value ? field.value.length > 0 : false}"
        @focus="focus = true"
        @focusout="focus = false"
        ref="text_area"
        v-model="field.value"
        :style="focus ? focusStyle : {}"
        :placeholder="hint">
            </textarea>
      <div class="error" v-if="field.invalid && !field.value">{{ 'This field is required' }}</div>
    </div>
  </div>
</template>

<script>
    import Field from './Field'

    export default {
        name: 'TextField',
        extends: Field,
        props: ['colors'],
        data() {
            return {
                focus: false
            }
        },
        methods: {
        },
        computed: {
            hint() {
                if (this.field.placeholder) {
                    return this.field.placeholder
                }
                return 'Please type your answer'
            },
            focusStyle() {
                return {
                    borderColor: this.colors.highlightColor
                }
            },
            dynamicStyle() {

                let val = this.field.value

                if (! this.$refs.text_area) return

                let scrollHeight = this.$refs.text_area.scrollHeight
                // @todo: Make textarea grow smaller when text becomes less as well
                console.log(scrollHeight)

                let style = {
                    'height': (scrollHeight + 1) + 'px'
                }

                return style
            }
        }
    }
</script>

<style scoped>
.text-selection-container textarea.text-field.text-field-input {
  border: solid 1px #bfc0c8;
  border-radius: 15px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.14);
  font-size: 13px;
  padding: 10px;
  width: 95%;
  margin: 0 auto;
}
.text-selection-container textarea.text-field.text-field-input.hasText {
    font-weight: 500;
}
.text-selection-container textarea.text-field.text-field-input:focus {
    outline: 0;
    border-color: #00aef1;
}
</style>



// WEBPACK FOOTER //
// node_modules/survey-fields/src/Question/Fields/TextField.vue